import React from 'react'

import { Box } from 'grommet'
import { useNavigate } from 'react-router-dom'




import LocalStorageService from '../../../../services/LocalStorageService'
import { useEffect, useState } from 'react'
import ActionButton from '../../../../components/compound/actionButton/ActionButton'
import { isCpomsEnabled, isServiceAdmin } from '../../../../utils/permissions'

const IncidentLinkBar = (props) => {
  // replace the name of the service user with the stored term
  const terms = LocalStorageService.get('terms')
  
  const user = LocalStorageService.get('userDetails')

  const navigate = useNavigate()

  const [links, setLinks] = useState([])

  useEffect(() => {

    const activeOrg = LocalStorageService.get('activeOrg') 

    let newLinks = []
    if (isServiceAdmin()) {
        newLinks.push({
            href: '/incident/search/global',
            icon: ['fal', 'search'],
            title: 'Incident Search',
        })
    } else {
        newLinks.push({
            href: '/incident/search/global',
            icon: ['fal', 'search'],
            title: 'Incident Search',
        })
    }
    newLinks.push({
        href: '/incident/drafts',
        icon: ['fal', 'pencil'],
        title: 'Incomplete Incidents',
    })

    if (isCpomsEnabled() && isServiceAdmin()) {
        newLinks.push({
            href: '/incident/cpoms',
            icon: ['fal', 'cloud-upload'],
            title: 'Synced to CPOMS',
        })
    }

    setLinks(newLinks)
    
  }, [])


  return (
    <Box background='white' direction='column' gap='small' margin={{ bottom: 'medium' }} round='small' flex='grow'>
        {/* <Box direction='row-responsive' justify='between' pad={{ horizontal: 'medium', vertical: 'small', bottom: 'none' }}>
            <Text size='large'>Quick Behaviours</Text>
        </Box> */}
        <Box direction='row-responsive' justify='start' pad={{ horizontal: 'medium', vertical: 'small' }}>
        <Box alignSelf='center' direction='row-responsive' gap='xsmall'>
            {links.map((link, index) => (
                <ActionButton
                    key={index}
                    labelIcon={link.icon}
                    label={link.title}
                    active={link.href === window.location.pathname}
                    onClick={() => navigate(link.href)}
                />
            ))}
        </Box>
        </Box>
    </Box>
  )
}


// menuSetup.push({
    //   linkHref: '/incident/drafts',
    //   icon: 'pencil',
    //   linkTitle: 'Incomplete Incidents',
    // });


export default IncidentLinkBar



